/**
 * Retro Island utilitarian facets — search-within, dual price slider,
 * Amazon full-screen mobile drawer helpers.
 */

(function () {
  var RAIL_SCROLL_KEY = 'ri-facets-rail-scroll';
  var priceSubmitTimer = null;

  function closestFacet(el) {
    return el && el.closest('.ri-facet');
  }

  function submitFacetForm(form, trigger) {
    if (!form) return;
    var host = form.closest('facet-filters-form');
    if (host && typeof host.onSubmitHandler === 'function') {
      host.onSubmitHandler({
        preventDefault: function () {},
        target: trigger || form.querySelector('input') || form,
        srcElement: trigger || form,
      });
    }
  }

  /* Platform shorthand (ps5, n64, snes) matches the full name in a filter list. */
  var SYSTEM_ABBREVIATIONS = {
    ps1: 'playstation',
    psx: 'playstation',
    ps2: 'playstation 2',
    ps3: 'playstation 3',
    ps4: 'playstation 4',
    ps5: 'playstation 5',
    psp: 'psp',
    vita: 'playstation vita',
    nes: 'nes',
    snes: 'super nintendo',
    n64: 'nintendo 64',
    gc: 'gamecube',
    gcn: 'gamecube',
    wii: 'wii',
    wiiu: 'wii u',
    switch: 'nintendo switch',
    switch2: 'nintendo switch 2',
    gb: 'gameboy',
    gbc: 'gameboy color',
    gba: 'gameboy advance',
    ds: 'nintendo ds',
    nds: 'nintendo ds',
    '3ds': 'nintendo 3ds',
    xb: 'xbox',
    xbox: 'xbox',
    '360': 'xbox 360',
    x360: 'xbox 360',
    xb1: 'xbox one',
    xone: 'xbox one',
    xsx: 'xbox series x',
    gen: 'sega genesis',
    sms: 'sega master system',
    sat: 'sega saturn',
    dc: 'sega dreamcast',
    gg: 'sega game gear',
  };

  function normFacetText(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function facetSlug(value) {
    return normFacetText(value).replace(/ /g, '');
  }

  function abbrevPhrase(token) {
    var key = String(token || '').replace(/[^a-z0-9]/g, '');
    return SYSTEM_ABBREVIATIONS[key] || null;
  }

  function labelHasPhrase(label, phrase) {
    if (!phrase) return false;
    if (facetSlug(label) === facetSlug(phrase)) return true;
    var idx = label.indexOf(phrase);
    if (idx === -1) return false;
    var beforeOk = idx === 0 || label.charAt(idx - 1) === ' ';
    if (!beforeOk) return false;
    var after = label.slice(idx + phrase.length);
    if (!after) return true;
    if (after.charAt(0) !== ' ') return false;
    var next = after.trim().split(' ')[0] || '';
    if (/^\d+$/.test(next)) return false;
    if (phrase === 'wii' && next === 'u') return false;
    if (phrase === 'gameboy' && (next === 'color' || next === 'advance')) return false;
    if (phrase === 'xbox' && (next === '360' || next === 'one' || next === 'series')) return false;
    if (phrase === 'nintendo switch' && next === '2') return false;
    return true;
  }

  function facetQueryMatch(label, query) {
    var nl = normFacetText(label);
    var nq = normFacetText(query);
    if (!nq) return true;
    if (nl.indexOf(nq) !== -1) return true;
    var tokens = nq.split(' ');
    if (tokens.length === 1) {
      var phrase = abbrevPhrase(tokens[0]);
      return !!(phrase && labelHasPhrase(nl, phrase));
    }
    return tokens.every(function (token) {
      if (nl.indexOf(token) !== -1) return true;
      var expanded = abbrevPhrase(token);
      return !!(expanded && labelHasPhrase(nl, expanded));
    });
  }

  /* —— Search within long lists (local only) —— */
  function onSearchInput(e) {
    var input = e.target;
    if (!input.matches || !input.matches('[data-ri-facet-search]')) return;
    e.stopImmediatePropagation();
    var facet = closestFacet(input);
    if (!facet) return;
    var q = input.value || '';
    var items = facet.querySelectorAll('[data-ri-facet-label]');
    var showMoreBtn = facet.querySelector('show-more-button');
    items.forEach(function (li) {
      var label = li.getAttribute('data-ri-facet-label') || '';
      var match = facetQueryMatch(label, q);
      li.classList.toggle('ri-facet-search-hide', !match);
      if (normFacetText(q)) li.classList.remove('hidden');
    });
    if (showMoreBtn) showMoreBtn.classList.toggle('ri-facet-search-hide', Boolean(normFacetText(q)));
    if (!normFacetText(q)) {
      var expanded = facet.querySelector('show-more-button .label-show-more.hidden');
      items.forEach(function (li) {
        if (!li.classList.contains('show-more-item')) return;
        if (expanded) {
          li.classList.remove('hidden');
          return;
        }
        /* Collapsed: keep checked extras visible in place; hide the rest */
        var checked = li.querySelector('input[type="checkbox"]:checked');
        if (checked) li.classList.remove('hidden');
        else li.classList.add('hidden');
      });
    }
  }

  /**
   * Show more/less for RI facets.
   * Natural order always. On Show less only: if a checked option would be
   * hidden, pin those checked extras to the top of the list first.
   */
  function onFacetShowMoreClick(e) {
    var button = e.target.closest('show-more-button button');
    if (!button) return;
    var showMore = button.closest('show-more-button');
    if (!showMore || !showMore.closest('.ri-facets, .ri-facet')) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var facet = closestFacet(showMore) || showMore.closest('.parent-display') || showMore.parentElement;
    if (!facet) return;

    var labelMore = showMore.querySelector('.label-show-more');
    var isExpanding = Boolean(labelMore && !labelMore.classList.contains('hidden'));

    showMore.querySelectorAll('.label-text').forEach(function (el) {
      el.classList.toggle('hidden');
    });

    if (isExpanding) {
      facet.querySelectorAll('.show-more-item').forEach(function (item) {
        item.classList.remove('hidden');
      });
      return;
    }

    /* Collapsing — pin checked show-more items only if they would be hidden */
    var list =
      facet.querySelector('ul.facets__list--vertical') ||
      facet.querySelector('ul.mobile-facets__list') ||
      facet.querySelector('ul.facets-layout-list');
    var extras = Array.prototype.slice.call(facet.querySelectorAll('.show-more-item'));
    var toPin = extras.filter(function (item) {
      return Boolean(item.querySelector('input[type="checkbox"]:checked'));
    });

    if (toPin.length && list) {
      var frag = document.createDocumentFragment();
      toPin.forEach(function (item) {
        item.classList.remove('show-more-item');
        item.classList.remove('hidden');
        frag.appendChild(item);
      });
      list.insertBefore(frag, list.firstChild);
    }

    facet.querySelectorAll('.show-more-item').forEach(function (item) {
      item.classList.add('hidden');
    });
  }

  /* —— Dual price slider —— */
  function parseNum(v) {
    var n = parseFloat(String(v).replace(/,/g, ''));
    return isNaN(n) ? 0 : n;
  }

  function clamp(n, lo, hi) {
    return Math.min(hi, Math.max(lo, n));
  }

  function syncPriceSlider(root, opts) {
    var minThumb = root.querySelector('[data-ri-price-thumb="min"]');
    var maxThumb = root.querySelector('[data-ri-price-thumb="max"]');
    var fill = root.querySelector('[data-ri-price-fill]');
    var gte = root.querySelector('[data-ri-price-gte]');
    var lte = root.querySelector('[data-ri-price-lte]');
    var inputMin = root.querySelector('[data-ri-price-input="min"]');
    var inputMax = root.querySelector('[data-ri-price-input="max"]');
    if (!minThumb || !maxThumb) return;

    var rangeMax = parseNum(root.getAttribute('data-range-max') || maxThumb.max);
    var minVal;
    var maxVal;
    var from = (opts && opts.from) || '';

    if (from === 'input-min' && inputMin) {
      minVal = clamp(parseNum(inputMin.value), 0, rangeMax);
      maxVal = parseNum(maxThumb.value);
      if (minVal > maxVal) minVal = maxVal;
      minThumb.value = String(minVal);
    } else if (from === 'input-max' && inputMax) {
      maxVal = clamp(parseNum(inputMax.value), 0, rangeMax);
      minVal = parseNum(minThumb.value);
      if (maxVal < minVal) maxVal = minVal;
      maxThumb.value = String(maxVal);
    } else {
      minVal = parseNum(minThumb.value);
      maxVal = parseNum(maxThumb.value);
      if (minVal > maxVal) {
        if (from === 'min') {
          minVal = maxVal;
          minThumb.value = String(minVal);
        } else {
          maxVal = minVal;
          maxThumb.value = String(maxVal);
        }
      }
    }

    minVal = Math.round(clamp(minVal, 0, rangeMax));
    maxVal = Math.round(clamp(maxVal, 0, rangeMax));
    minThumb.value = String(minVal);
    maxThumb.value = String(maxVal);

    var minPct = rangeMax > 0 ? (minVal / rangeMax) * 100 : 0;
    var maxPct = rangeMax > 0 ? (maxVal / rangeMax) * 100 : 100;
    var track = root.querySelector('[data-ri-price-track]') || root.querySelector('.ri-price-slider__track');
    if (track) {
      track.style.setProperty('--ri-price-min', minPct + '%');
      track.style.setProperty('--ri-price-max', maxPct + '%');
    }
    if (fill) {
      fill.style.left = minPct + '%';
      fill.style.width = Math.max(0, maxPct - minPct) + '%';
    }
    if (inputMin && document.activeElement !== inputMin) inputMin.value = String(minVal);
    if (inputMax && document.activeElement !== inputMax) inputMax.value = String(maxVal);

    /* Empty GTE when at floor; empty LTE when at ceiling — matches Shopify defaults */
    if (gte) gte.value = minVal > 0 ? String(minVal) : '';
    if (lte) lte.value = maxVal < rangeMax ? String(maxVal) : '';
  }

  function onPriceSliderInput(e) {
    var thumb = e.target;
    if (!thumb.matches || !thumb.matches('[data-ri-price-thumb]')) return;
    e.stopImmediatePropagation();
    var root = thumb.closest('[data-ri-price-slider]');
    if (!root) return;
    syncPriceSlider(root, { from: thumb.getAttribute('data-ri-price-thumb') });
  }

  function schedulePriceSubmit(form, trigger) {
    if (priceSubmitTimer) window.clearTimeout(priceSubmitTimer);
    priceSubmitTimer = window.setTimeout(function () {
      priceSubmitTimer = null;
      submitFacetForm(form, trigger);
    }, 350);
  }

  /*
   * Touch screens: the two stacked range inputs only take touches on their round thumbs, and iPhone Safari
   * ignores that, so the slider did nothing on a phone. Drive it by hand: a touch on the slider row moves
   * whichever thumb is closer, dragging updates it, and lifting the finger applies the price filter.
   */
  var priceDrag = null;

  function priceValueAt(thumb, clientX) {
    var box = thumb.getBoundingClientRect();
    var half = 10;
    var span = Math.max(1, box.width - half * 2);
    var ratio = clamp((clientX - box.left - half) / span, 0, 1);
    return Math.round(ratio * parseNum(thumb.max));
  }

  function setPriceThumb(thumb, value) {
    if (String(thumb.value) === String(value)) return;
    thumb.value = String(value);
    thumb.dispatchEvent(new Event('input', { bubbles: true }));
  }

  function onPriceTouchStart(e) {
    if (!e.touches || e.touches.length !== 1) return;
    var root = e.target.closest && e.target.closest('[data-ri-price-slider]');
    if (!root || e.target.closest('[data-ri-price-input]')) return;
    var minThumb = root.querySelector('[data-ri-price-thumb="min"]');
    var maxThumb = root.querySelector('[data-ri-price-thumb="max"]');
    if (!minThumb || !maxThumb) return;
    var touch = e.touches[0];
    var row = maxThumb.getBoundingClientRect();
    if (touch.clientY < row.top - 14 || touch.clientY > row.bottom + 14) return;
    var value = priceValueAt(maxThumb, touch.clientX);
    var minVal = parseNum(minThumb.value);
    var maxVal = parseNum(maxThumb.value);
    var thumb;
    if (value <= minVal) thumb = minThumb;
    else if (value >= maxVal) thumb = maxThumb;
    else thumb = Math.abs(value - minVal) <= Math.abs(maxVal - value) ? minThumb : maxThumb;
    e.preventDefault();
    priceDrag = { thumb: thumb };
    setPriceThumb(thumb, value);
  }

  function onPriceTouchMove(e) {
    if (!priceDrag || !e.touches || !e.touches.length) return;
    e.preventDefault();
    setPriceThumb(priceDrag.thumb, priceValueAt(priceDrag.thumb, e.touches[0].clientX));
  }

  function onPriceTouchEnd() {
    if (!priceDrag) return;
    var thumb = priceDrag.thumb;
    priceDrag = null;
    thumb.dispatchEvent(new Event('change', { bubbles: true }));
  }

  document.addEventListener('touchstart', onPriceTouchStart, { capture: true, passive: false });
  document.addEventListener('touchmove', onPriceTouchMove, { capture: true, passive: false });
  document.addEventListener('touchend', onPriceTouchEnd, true);
  document.addEventListener('touchcancel', onPriceTouchEnd, true);

  function onPriceSliderChange(e) {
    var thumb = e.target;
    if (!thumb.matches || !thumb.matches('[data-ri-price-thumb]')) return;
    e.stopImmediatePropagation();
    var root = thumb.closest('[data-ri-price-slider]');
    if (!root) return;
    syncPriceSlider(root, { from: thumb.getAttribute('data-ri-price-thumb') });
    schedulePriceSubmit(root.closest('form'), thumb);
  }

  function onPriceTypeInput(e) {
    var input = e.target;
    if (!input.matches || !input.matches('[data-ri-price-input]')) return;
    e.stopImmediatePropagation();
    var root = input.closest('[data-ri-price-slider]');
    if (!root) return;
    var which = input.getAttribute('data-ri-price-input');
    syncPriceSlider(root, { from: which === 'min' ? 'input-min' : 'input-max' });
  }

  function onPriceTypeCommit(e) {
    var input = e.target;
    if (!input.matches || !input.matches('[data-ri-price-input]')) return;
    e.stopImmediatePropagation();
    var root = input.closest('[data-ri-price-slider]');
    if (!root) return;
    var which = input.getAttribute('data-ri-price-input');
    syncPriceSlider(root, { from: which === 'min' ? 'input-min' : 'input-max' });
    /* Snap typed field to clamped value */
    input.value = which === 'min'
      ? root.querySelector('[data-ri-price-thumb="min"]').value
      : root.querySelector('[data-ri-price-thumb="max"]').value;
    schedulePriceSubmit(root.closest('form'), input);
  }

  function onPriceTypeKeydown(e) {
    var input = e.target;
    if (!input.matches || !input.matches('[data-ri-price-input]')) return;
    if (e.key === 'Enter') {
      e.preventDefault();
      input.blur();
    }
  }

  function initPriceSliders(scope) {
    (scope || document).querySelectorAll('[data-ri-price-slider]').forEach(function (root) {
      syncPriceSlider(root, {});
    });
  }

  function onSeeResults(e) {
    var btn = e.target.closest('[data-ri-facets-close]');
    if (!btn) return;
    var wrap = btn.closest('.mobile-facets__wrapper');
    var summary = wrap && wrap.querySelector('summary');
    if (summary) summary.click();
  }

  function saveRailScroll() {
    var rail = document.querySelector('#FacetsWrapperDesktop');
    if (rail) sessionStorage.setItem(RAIL_SCROLL_KEY, String(rail.scrollTop));
  }

  function restoreRailScroll() {
    var rail = document.querySelector('#FacetsWrapperDesktop');
    if (!rail) return;
    var y = sessionStorage.getItem(RAIL_SCROLL_KEY);
    if (y != null) rail.scrollTop = parseInt(y, 10) || 0;
  }

  function clearFacetSearches(scope) {
    (scope || document).querySelectorAll('[data-ri-facet-search]').forEach(function (input) {
      if (!input.value) return;
      input.value = '';
      var facet = closestFacet(input);
      if (!facet) return;
      facet.querySelectorAll('[data-ri-facet-label]').forEach(function (li) {
        li.classList.remove('ri-facet-search-hide');
        if (li.classList.contains('show-more-item')) {
          var expanded = facet.querySelector('show-more-button .label-show-more.hidden');
          if (expanded) {
            li.classList.remove('hidden');
          } else {
            var checked = li.querySelector('input[type="checkbox"]:checked');
            if (checked) li.classList.remove('hidden');
            else li.classList.add('hidden');
          }
        }
      });
      var showMoreBtn = facet.querySelector('show-more-button');
      if (showMoreBtn) showMoreBtn.classList.remove('ri-facet-search-hide');
    });
  }

  /* —— Ephemeral PriceCharting "hide games I own" filter —— */
  function pcApi() {
    return window.RIPriceCharting || null;
  }

  function gameCards() {
    var grid = document.getElementById('product-grid') || document;
    return Array.prototype.slice.call(grid.querySelectorAll('[data-ri-game]'));
  }

  function hideOwnedActive() {
    var api = pcApi();
    return Boolean(api && api.hasCollection() && api.hideOwnedPref());
  }

  function setHideOwnedCheckboxes(on) {
    document.querySelectorAll('[data-ri-hide-owned]').forEach(function (cb) {
      cb.checked = on;
      var label = cb.closest('.facet-checkbox');
      if (label) label.classList.toggle('active', on);
    });
  }

  function updateOwnedCount(n) {
    document.querySelectorAll('[data-ri-owned-count]').forEach(function (el) {
      el.textContent = n > 0 ? '(' + n + ')' : '';
    });
  }

  function applyOwnedFilter() {
    var api = pcApi();
    var cards = gameCards();
    var on = hideOwnedActive();
    var matches = 0;

    cards.forEach(function (card) {
      var owned = api
        ? api.isOwned(
            card.getAttribute('data-ri-game-name'),
            card.getAttribute('data-ri-platform')
          )
        : false;
      if (owned) matches += 1;
      var item = card.closest('.grid__item') || card.closest('li') || card.parentElement;
      if (!item) return;
      item.classList.toggle('ri-owned-hidden', on && owned);
    });

    updateOwnedCount(matches);

    /* Owned rows removed/restored — let the shelf recompute uniform heights */
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(function () {
        window.dispatchEvent(new Event('resize'));
      });
    }
  }

  function updateCollectionFacet() {
    var api = pcApi();
    var show = Boolean(api && api.hasCollection()) && gameCards().length > 0;
    /* Visibility is class-driven (see ri-collection-sync.css). The pre-paint
       .ri-has-collection + server .ri-facets--has-games combo handles the common
       case with no stutter; this is the post-paint fallback for missed pages. */
    document.querySelectorAll('.ri-facets').forEach(function (el) {
      el.classList.toggle('ri-facets--cf-show', show);
    });
    setHideOwnedCheckboxes(hideOwnedActive());
  }

  /* —— "Hide re-release editions" filter (Hits / Selects / Choice) —— */
  /* Independent of the PriceCharting collection. Applied only on game collections. */
  var RELEASE_KEY = 'ri:hide-rereleases';
  var RERELEASE_RE = /\[([^\]]*)\]/g;
  var RERELEASE_WORDS = /\b(?:hits|selects|choice)\b/i;

  function hideReleasesPref() {
    try {
      return window.sessionStorage.getItem(RELEASE_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function setHideReleasesPref(on) {
    try {
      if (on) window.sessionStorage.setItem(RELEASE_KEY, '1');
      else window.sessionStorage.removeItem(RELEASE_KEY);
    } catch (e) {
      /* ignore */
    }
  }

  function isRerelease(name) {
    if (!name) return false;
    var str = String(name);
    var m;
    RERELEASE_RE.lastIndex = 0;
    while ((m = RERELEASE_RE.exec(str)) !== null) {
      if (RERELEASE_WORDS.test(m[1])) return true;
    }
    return false;
  }

  function setHideReleasesCheckboxes(on) {
    document.querySelectorAll('[data-ri-hide-rereleases]').forEach(function (cb) {
      cb.checked = on;
      var label = cb.closest('.facet-checkbox');
      if (label) label.classList.toggle('active', on);
    });
  }

  function updateReleaseCount(n) {
    document.querySelectorAll('[data-ri-rerelease-count]').forEach(function (el) {
      el.textContent = n > 0 ? '(' + n + ')' : '';
    });
  }

  function applyReleaseFilter() {
    var cards = gameCards();
    var onPage = Boolean(document.querySelector('.ri-facets--game-collection'));
    var on = onPage && hideReleasesPref();
    var matches = 0;

    cards.forEach(function (card) {
      var rerelease = isRerelease(card.getAttribute('data-ri-game-name'));
      if (rerelease) matches += 1;
      var item = card.closest('.grid__item') || card.closest('li') || card.parentElement;
      if (!item) return;
      item.classList.toggle('ri-rerelease-hidden', on && rerelease);
    });

    updateReleaseCount(matches);
    document.querySelectorAll('.ri-facets').forEach(function (el) {
      el.classList.toggle('ri-facets--has-editions', matches > 0);
    });
  }

  function onHideReleasesChange(e) {
    var cb = e.target;
    if (!cb.matches || !cb.matches('[data-ri-hide-rereleases]')) return;
    e.stopImmediatePropagation();
    setHideReleasesPref(cb.checked);
    setHideReleasesCheckboxes(cb.checked);
    reflectFilterClasses();
    applyReleaseFilter();
    reflowShelf();
  }

  /* Keep pre-paint <html> flags in sync with the current toggle prefs so the
     checkbox visual (driven by CSS, see ri-facets.css) never flashes unchecked
     on navigation before JS re-applies `checked`. Mirrors `.ri-has-collection`. */
  function reflectFilterClasses() {
    var root = document.documentElement;
    root.classList.toggle('ri-hide-rereleases', hideReleasesPref());
    root.classList.toggle('ri-hide-owned', hideOwnedActive());
    var langs = langPref();
    LANG_VALUES.forEach(function (lang) {
      root.classList.toggle('ri-lang-' + lang, langs.indexOf(lang) !== -1);
    });
  }

  function reflowShelf() {
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(function () {
        window.dispatchEvent(new Event('resize'));
      });
    }
  }

  function onHideOwnedChange(e) {
    var cb = e.target;
    if (!cb.matches || !cb.matches('[data-ri-hide-owned]')) return;
    e.stopImmediatePropagation();
    var api = pcApi();
    if (api) api.setHideOwnedPref(cb.checked);
    setHideOwnedCheckboxes(cb.checked);
    reflectFilterClasses();
    applyOwnedFilter();
  }

  /* —— Sealed Pokemon Language filter (title contains Japanese / Chinese) —— */
  var LANG_KEY = 'ri:sealed-lang';
  var LANG_VALUES = ['english', 'japanese', 'chinese'];

  function langPref() {
    try {
      var raw = window.sessionStorage.getItem(LANG_KEY) || '';
      return raw.split(',').filter(function (v) {
        return LANG_VALUES.indexOf(v) !== -1;
      });
    } catch (e) {
      return [];
    }
  }

  function setLangPref(values) {
    try {
      var next = LANG_VALUES.filter(function (v) {
        return values.indexOf(v) !== -1;
      });
      if (next.length) window.sessionStorage.setItem(LANG_KEY, next.join(','));
      else window.sessionStorage.removeItem(LANG_KEY);
    } catch (e) {
      /* ignore */
    }
  }

  function productLangs(title) {
    var t = String(title || '').toLowerCase();
    var langs = [];
    if (t.indexOf('chinese') !== -1) langs.push('chinese');
    if (t.indexOf('japanese') !== -1) langs.push('japanese');
    if (!langs.length) langs.push('english');
    return langs;
  }

  function langCards() {
    var grid = document.getElementById('product-grid') || document;
    return Array.prototype.slice.call(grid.querySelectorAll('[data-ri-product-title]'));
  }

  function setLangCheckboxes(values) {
    document.querySelectorAll('[data-ri-lang]').forEach(function (cb) {
      var on = values.indexOf(cb.getAttribute('data-ri-lang')) !== -1;
      cb.checked = on;
      var label = cb.closest('.facet-checkbox');
      if (label) label.classList.toggle('active', on);
    });
  }

  function updateLangCounts(counts) {
    LANG_VALUES.forEach(function (lang) {
      var n = counts[lang] || 0;
      document.querySelectorAll('[data-ri-lang-count="' + lang + '"]').forEach(function (el) {
        el.textContent = n > 0 ? '(' + n + ')' : '';
      });
    });
  }

  function applyLangFilter() {
    if (!document.querySelector('.ri-facets--sealed-pokemon')) return;
    var selected = langPref();
    var counts = { english: 0, japanese: 0, chinese: 0 };

    langCards().forEach(function (card) {
      var langs = productLangs(card.getAttribute('data-ri-product-title'));
      langs.forEach(function (lang) {
        if (counts[lang] != null) counts[lang] += 1;
      });
      var hide = selected.length > 0 && !langs.some(function (lang) {
        return selected.indexOf(lang) !== -1;
      });
      var item = card.closest('.grid__item') || card.closest('li') || card.parentElement;
      if (!item) return;
      item.classList.toggle('ri-lang-hidden', hide);
    });

    updateLangCounts(counts);
  }

  function onLangChange(e) {
    var cb = e.target;
    if (!cb.matches || !cb.matches('[data-ri-lang]')) return;
    e.stopImmediatePropagation();
    var next = langPref().slice();
    var value = cb.getAttribute('data-ri-lang');
    var idx = next.indexOf(value);
    if (cb.checked && idx === -1) next.push(value);
    if (!cb.checked && idx !== -1) next.splice(idx, 1);
    setLangPref(next);
    setLangCheckboxes(next);
    reflectFilterClasses();
    applyLangFilter();
    reflowShelf();
  }

  function refreshCollectionFilter() {
    /* PARKED: Sync Collection "Hide games I own". Uncomment with the header button.
    updateCollectionFacet();
    applyOwnedFilter();
    */
    setHideReleasesCheckboxes(hideReleasesPref());
    setLangCheckboxes(langPref());
    reflectFilterClasses();
    applyReleaseFilter();
    applyLangFilter();
  }

  /* Clear filters also resets the page-side toggles (language, re-releases), which the server never sees.
     With no server filter on, the link has nothing to load, so stay put and just reset. */
  function onClearAllClick(e) {
    var link = e.target.closest && e.target.closest('.ri-facets__clear-link');
    if (!link) return;
    setHideReleasesPref(false);
    setLangPref([]);
    refreshCollectionFilter();
    if (link.closest('.ri-facets__clear-all--empty')) {
      e.preventDefault();
      e.stopImmediatePropagation();
      reflowShelf();
    }
  }

  var filterScrollTimer = 0;
  /* A render asked to keep the page where it is (the Show N per page menu) skips the jump to the top. */
  var keepScrollOnRender = false;
  function scrollCollectionToTop() {
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    if (y <= 2) return;
    window.dispatchEvent(new CustomEvent('ri:header-release-scroll'));
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    window.setTimeout(function () {
      var left = window.pageYOffset || document.documentElement.scrollTop || 0;
      if (left > 0) window.scrollTo({ top: 0, behavior: 'auto' });
    }, reduce ? 40 : 700);
  }

  function scheduleFilterScroll() {
    if (keepScrollOnRender) return;
    window.clearTimeout(filterScrollTimer);
    filterScrollTimer = window.setTimeout(scrollCollectionToTop, 80);
  }

  /* Phone filter bar: remember which drop is open and how far its list is scrolled,
     so a selection re-render keeps the same drop open at the same place. */
  var pendingDropState = null;

  /* Phone filter taps made after a request starts. Dawn rebuilds the checkboxes from the server reply,
     which would undo a tap that landed while that reply was on its way. Re-apply those taps after each reply. */
  var pendingMobileChecks = {};
  var activeFilterFetch = null;

  function onMobileCheckChange(event) {
    var input = event.target;
    if (!input || input.type !== 'checkbox' || !input.id) return;
    if (!input.closest || !input.closest('#FacetFiltersFormMobile')) return;
    pendingMobileChecks[input.id] = input.checked;
  }

  /*
   * Phone filter lists open outside the sideways-scrolling chip row. On an iPhone a fixed list inside
   * that scrolling row was clipped to nothing: the chip showed open and nothing appeared. While open,
   * the list moves to the end of its own form (so every filter still submits), and moves back on close.
   */
  function panelOf(details) {
    if (!details) return null;
    return details._riPanel || details.querySelector(':scope > .ri-facet-drop__panel');
  }

  function dropOf(el) {
    if (!el || !el.closest) return null;
    var drop = el.closest('.ri-facet-drop');
    if (drop) return drop;
    var panel = el.closest('.ri-facet-drop__panel');
    return panel && panel._riHome ? panel._riHome : null;
  }

  function portalOpen(details) {
    var panel = panelOf(details);
    var form = details.closest('#FacetFiltersFormMobile');
    if (!panel || !form || !window.matchMedia('(max-width: 989px)').matches) return;
    if (panel.parentNode === form) return;
    panel._riHome = details;
    details._riPanel = panel;
    panel.classList.add('is-portal');
    form.appendChild(panel);
  }

  function portalClose(details) {
    var panel = details && details._riPanel;
    if (!panel) return;
    details._riPanel = null;
    panel.classList.remove('is-portal');
    if (panel.parentNode !== details) details.appendChild(panel);
  }

  /* Before Dawn swaps the filter markup, every list goes home, so no list is left floating in the form. */
  function portalCloseAll() {
    document.querySelectorAll('#FacetFiltersFormMobile > .ri-facet-drop__panel.is-portal').forEach(function (panel) {
      if (panel._riHome && panel._riHome.isConnected) portalClose(panel._riHome);
      else panel.remove();
    });
  }

  /* The phone bar is drawn once per page load, so its count badge is kept in step with the boxes here. */
  function updateFacetCount(drop) {
    var summary = drop.querySelector('.ri-facet-drop__summary');
    var panel = panelOf(drop);
    if (!summary || !panel) return;
    var picked = 0;
    panel.querySelectorAll('input[type=checkbox]').forEach(function (box) {
      if (box.checked) picked += 1;
    });
    var badge = summary.querySelector('.ri-facet-drop__count');
    if (picked === 0) {
      if (badge) badge.remove();
      return;
    }
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'ri-facet-drop__count';
      summary.insertBefore(badge, summary.querySelector('.header__menu-chevron'));
    }
    badge.textContent = String(picked);
    badge.setAttribute('aria-label', picked + ' selected');
  }

  function onMobileCountChange(event) {
    var input = event.target;
    if (!input || input.type !== 'checkbox' || !input.closest) return;
    var drop = dropOf(input);
    if (drop) updateFacetCount(drop);
  }

  function applyPendingMobileChecks() {
    Object.keys(pendingMobileChecks).forEach(function (id) {
      var input = document.getElementById(id);
      if (input && input.type === 'checkbox') input.checked = pendingMobileChecks[id];
    });
  }

  function cancelActiveFilterFetch() {
    if (activeFilterFetch) activeFilterFetch.abort();
    activeFilterFetch = null;
  }

  function phoneDrops() {
    var bar = document.querySelector('.ri-facets__bar');
    return bar ? Array.prototype.slice.call(bar.querySelectorAll('.ri-facet-drop')) : [];
  }

  function captureOpenDrop() {
    var drops = phoneDrops();
    var index = -1;
    drops.forEach(function (d, i) {
      if (d.open) index = i;
    });
    if (index < 0) return null;
    var openPanel = panelOf(drops[index]);
    var scroller = openPanel ? openPanel.firstElementChild : null;
    var filter = openPanel ? openPanel.querySelector('.js-filter') : null;
    return { index: index, id: filter ? filter.id : '', scrollTop: scroller ? scroller.scrollTop : 0 };
  }

  /* By the filter inside it first: a filter that drops out or comes back moves the others along. */
  function restoreOpenDrop(state) {
    if (!state) return;
    var drops = phoneDrops();
    var details = null;
    if (state.id) {
      details = drops.filter(function (d) {
        var panel = panelOf(d);
        return panel && panel.querySelector('[id="' + state.id + '"]');
      })[0];
    }
    if (!details && !state.id) details = drops[state.index];
    if (!details) return;
    if (!details.open) {
      details.classList.add('ri-facet-drop--keep');
      details.open = true;
      window.setTimeout(function () {
        details.classList.remove('ri-facet-drop--keep');
      }, 700);
    }
    portalOpen(details);
    var keptPanel = panelOf(details);
    var scroller = keptPanel ? keptPanel.firstElementChild : null;
    if (scroller) scroller.scrollTop = state.scrollTop;
    placeFacetPanel(details);
  }

  /* Search within a console: once the search page's console filter is cleared or changed, the header's
     "in PS2 Games" chip no longer matches the list, so it goes and the next search covers the whole store. */
  function syncHeaderSearchScope(searchParams) {
    if (!/\/search\/?$/.test(window.location.pathname)) return;
    var forms = document.querySelectorAll('.ri-header-search__form[data-ri-scope-gid]');
    if (!forms.length) return;
    var values = new URLSearchParams(searchParams || '').getAll('filter.v.t.shopify.video-game-platform');
    if (values.length === 1 && values[0] === forms[0].getAttribute('data-ri-scope-gid')) return;
    forms.forEach(function (form) {
      form.removeAttribute('data-ri-scope-gid');
      form.removeAttribute('data-ri-scope-type');
      form.removeAttribute('data-ri-scope-label');
      form.classList.remove('is-scoped');
      form.querySelectorAll('[data-ri-search-scope], [data-ri-scope-input]').forEach(function (node) {
        node.remove();
      });
      var input = form.querySelector('.ri-header-search__input');
      if (input) input.setAttribute('placeholder', 'Search games, systems, cards…');
    });
    document.querySelectorAll('predictive-search').forEach(function (el) {
      el.cachedResults = {};
    });
  }

  /* The search page's "N results for mario" line sits above the grid, so Dawn never redraws it. */
  function renderSearchStatus(html) {
    var line = document.querySelector('[data-ri-search-status]');
    if (!line) return;
    var next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-ri-search-status]');
    if (next) line.innerHTML = next.innerHTML;
  }

  function patchFacetsRender() {
    if (!window.customElements || !customElements.get('facet-filters-form')) return false;
    var Ctor = customElements.get('facet-filters-form');
    if (!Ctor || !Ctor.renderPage || Ctor._riPatched) return Boolean(Ctor && Ctor.renderPage);
    var origPage = Ctor.renderPage.bind(Ctor);
    if (Ctor.renderProductCount) {
      var origCount = Ctor.renderProductCount.bind(Ctor);
      Ctor.renderProductCount = function (html, updateEvent) {
        renderSearchStatus(html);
        origCount(html, updateEvent);
      };
    }
    Ctor.renderPage = function (searchParams, event, updateURLHash) {
      syncHeaderSearchScope(searchParams);
      keepScrollOnRender = window.riKeepScrollNextRender === true;
      window.riKeepScrollNextRender = false;
      saveRailScroll();
      clearFacetSearches(document);
      var dropState = captureOpenDrop();
      pendingDropState = dropState;
      /* The open list stays where it is while the new results load; it goes home only as the filters are redrawn
         (renderFilters below), in the same moment it is put back, so it never blinks out (owner, 2026-10-23). */
      var gridHost = document.getElementById('ProductGridContainer');
      if (gridHost) gridHost.classList.add('ri-grid-updating');
      origPage(searchParams, event, updateURLHash);
      window.setTimeout(function () {
        clearFacetSearches(document);
        restoreRailScroll();
        restoreOpenDrop(dropState);
        initPriceSliders(document);
        refreshCollectionFilter();
        if (window.RICardScrub && typeof window.RICardScrub.init === 'function') {
          window.RICardScrub.init(document.getElementById('product-grid') || document);
        }
        if (typeof window.riMergeContentsFilters === 'function') window.riMergeContentsFilters(document);
      }, 50);
      window.setTimeout(function () {
        clearFacetSearches(document);
        restoreRailScroll();
        restoreOpenDrop(dropState);
        refreshCollectionFilter();
        if (window.RICardScrub && typeof window.RICardScrub.init === 'function') {
          window.RICardScrub.init(document.getElementById('product-grid') || document);
        }
        if (typeof window.riMergeContentsFilters === 'function') window.riMergeContentsFilters(document);
        scheduleFilterScroll();
      }, 450);
    };

    if (Ctor.renderProductGridContainer && !Ctor._riGridPatched) {
      var origGrid = Ctor.renderProductGridContainer.bind(Ctor);
      Ctor.renderProductGridContainer = function (html) {
        var host = document.getElementById('ProductGridContainer');
        if (!host) {
          origGrid(html);
          return;
        }

        host.classList.add('ri-grid-updating');
        /* Hold the old height through the swap so the footer does not jump up and back. */
        host.style.minHeight = Math.ceil(host.getBoundingClientRect().height) + 'px';

        var swap = function () {
          origGrid(html);
          var next = document.getElementById('ProductGridContainer');
          if (!next) return;
          /* Keep hidden until shelf paints, then soft fade in */
          next.classList.add('ri-grid-updating');
          window.requestAnimationFrame(function () {
            window.requestAnimationFrame(function () {
              next.classList.remove('ri-grid-updating');
              next.classList.add('ri-grid-updated');
              refreshCollectionFilter();
              syncSortLabel();
              scheduleFilterScroll();
              window.setTimeout(function () {
                next.classList.remove('ri-grid-updated');
              }, 240);
              window.setTimeout(function () {
                next.style.minHeight = '';
              }, 600);
            });
          });
        };

        /* Let opacity hit 0 (incl. ATC) before replacing DOM */
        var reduce =
          window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.setTimeout(swap, reduce ? 0 : 200);
      };
      Ctor._riGridPatched = true;
    }

    if (Ctor.renderActiveFacets && !Ctor._riChipsPatched) {
      var origChips = Ctor.renderActiveFacets.bind(Ctor);
      Ctor.renderActiveFacets = function (html) {
        origChips(html);
        var src = html.querySelector('.ri-facets__chips--drawer');
        var dest = document.querySelector('.ri-facets__chips--drawer');
        if (src && dest) dest.innerHTML = src.innerHTML;
      };
      Ctor._riChipsPatched = true;
    }
    /* After Dawn swaps a single filter’s counts, wipe any leftover search text */
    if (Ctor.renderCounts && !Ctor._riCountsPatched) {
      var origCounts = Ctor.renderCounts.bind(Ctor);
      Ctor.renderCounts = function (source, target) {
        origCounts(source, target);
        clearFacetSearches(target && target.closest ? target.closest('.ri-facets') || document : document);
      };
      Ctor._riCountsPatched = true;
    }
    if (Ctor.renderFilters && !Ctor._riMergePatched) {
      var origFilters = Ctor.renderFilters.bind(Ctor);
      Ctor.renderFilters = function (html, event) {
        portalCloseAll();
        /* A filter above the one being clicked can drop out or come back (Contents with Sierra on PS1). Keep the
           clicked filter where it was on screen by moving the rail's scroll by the same amount. */
        var clicked = event && event.target && event.target.closest ? event.target.closest('.js-filter') : null;
        var rail = clicked ? clicked.closest('#FacetsWrapperDesktop') : null;
        var top0 = rail ? clicked.getBoundingClientRect().top : 0;
        origFilters(html, event);
        if (rail && clicked.isConnected) {
          var delta = clicked.getBoundingClientRect().top - top0;
          if (Math.abs(delta) >= 1) {
            rail.scrollTo({ top: rail.scrollTop + delta, behavior: 'instant' });
            saveRailScroll();
          }
        }
        applyPendingMobileChecks();
        /* Kept until the redraw uses it: a timer cleared it before a slow reply came back, and the list stayed shut. */
        if (pendingDropState) {
          restoreOpenDrop(pendingDropState);
          pendingDropState = null;
        }
        if (typeof window.riMergeContentsFilters === 'function') window.riMergeContentsFilters(document);
        if (typeof window.RIFitSort === 'function') window.RIFitSort();
      };
      Ctor._riMergePatched = true;
    }

    if (!Ctor._riRequestPatched) {
      /* Each filter change is its own request. Only the newest one may paint, so an older reply
         cannot overwrite the filters the shopper has picked since. */
      var origSubmit = Ctor.prototype.onSubmitHandler;
      if (origSubmit) {
        Ctor.prototype.onSubmitHandler = function (event) {
          pendingMobileChecks = {};
          return origSubmit.call(this, event);
        };
      }
      var origFetch = Ctor.renderSectionFromFetch;
      var isPhone = function () {
        return window.matchMedia('(max-width: 749px)').matches;
      };
      Ctor.renderSectionFromFetch = function (url, event, updateEvent) {
        if (!isPhone() || typeof AbortController === 'undefined') {
          return origFetch.call(this, url, event, updateEvent);
        }
        cancelActiveFilterFetch();
        var controller = new AbortController();
        activeFilterFetch = controller;
        fetch(url, { signal: controller.signal })
          .then(function (response) {
            return response.text();
          })
          .then(function (html) {
            if (activeFilterFetch !== controller) return;
            activeFilterFetch = null;
            Ctor.filterData = [...Ctor.filterData, { html: html, url: url }];
            Ctor.renderSection(html, event, updateEvent);
          })
          .catch(function (error) {
            if (error && error.name === 'AbortError') return;
            console.error(error);
            if (updateEvent && updateEvent.reject) updateEvent.reject(error);
          });
      };
      var origCache = Ctor.renderSectionFromCache;
      if (origCache) {
        Ctor.renderSectionFromCache = function (filterDataUrl, event, updateEvent) {
          if (isPhone()) cancelActiveFilterFetch();
          return origCache.call(this, filterDataUrl, event, updateEvent);
        };
      }
      Ctor._riRequestPatched = true;
    }
    Ctor._riPatched = true;
    return true;
  }

  /* Back from a product: the shelf holds rows hidden until they are measured, so the
     browser's own restore can land short. Remember where the card was clicked and
     finish the restore once the shelf is ready. */
  var SCROLL_KEY = 'ri:plp-scroll';

  function rememberCardScroll(event) {
    var link = event.target.closest && event.target.closest('a[href*="/products/"]');
    if (!link || !link.closest('#ProductGridContainer')) return;
    try {
      sessionStorage.setItem(
        SCROLL_KEY,
        JSON.stringify({ url: location.pathname + location.search, y: window.scrollY, t: Date.now() })
      );
    } catch (e) {}
  }

  function restoreCardScroll() {
    var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    if (!nav || nav.type !== 'back_forward') return;
    var saved = null;
    try {
      saved = JSON.parse(sessionStorage.getItem(SCROLL_KEY) || 'null');
    } catch (e) {}
    if (!saved || saved.url !== location.pathname + location.search) return;
    if (Date.now() - saved.t > 30 * 60 * 1000) return;
    var tries = 0;
    var done = false;
    var userMoved = false;
    var stop = function () {
      userMoved = true;
    };
    window.addEventListener('wheel', stop, { passive: true, once: true });
    window.addEventListener('touchstart', stop, { passive: true, once: true });
    window.addEventListener('keydown', stop, { once: true });
    (function attempt() {
      if (done || userMoved) return;
      tries += 1;
      var grid = document.getElementById('product-grid');
      var ready = !grid || !grid.classList.contains('ri-shelf-pending');
      if (ready || tries > 20) {
        done = true;
        if (Math.abs(window.scrollY - saved.y) > 40) window.scrollTo(0, saved.y);
        return;
      }
      window.setTimeout(attempt, 100);
    })();
  }

  function init() {
    document.addEventListener('click', rememberCardScroll, true);
    restoreCardScroll();
    document.addEventListener('input', onSearchInput, true);
    document.addEventListener('input', onPriceSliderInput, true);
    document.addEventListener('input', onPriceTypeInput, true);
    document.addEventListener('change', onPriceSliderChange, true);
    document.addEventListener('change', onPriceTypeCommit, true);
    document.addEventListener('blur', onPriceTypeCommit, true);
    document.addEventListener('keydown', onPriceTypeKeydown, true);
    document.addEventListener('click', onFacetShowMoreClick, true);
    document.addEventListener('change', onMobileCheckChange, true);
    document.addEventListener('change', onMobileCountChange, true);
    document.addEventListener('click', onSeeResults);
    document.addEventListener('change', onHideOwnedChange, true);
    document.addEventListener('change', onHideReleasesChange, true);
    document.addEventListener('change', onLangChange, true);
    document.addEventListener('click', onClearAllClick, true);
    document.addEventListener('ri:collection-changed', refreshCollectionFilter);

    if (!patchFacetsRender() && window.customElements && window.customElements.whenDefined) {
      window.customElements.whenDefined('facet-filters-form').then(patchFacetsRender);
    }

    initPriceSliders(document);
    restoreRailScroll();
    refreshCollectionFilter();
    initSortMenus();
    markMultilineHead();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(markMultilineHead);
  }

  function sortMenuWidth(menu) {
    var prevWidth = menu.style.width;
    var prevMin = menu.style.minWidth;
    menu.style.width = 'max-content';
    menu.style.minWidth = '0';
    var width = Math.ceil(menu.getBoundingClientRect().width);
    menu.style.width = prevWidth;
    menu.style.minWidth = prevMin;
    return width;
  }

  function sortNaturalWidth(details) {
    var prev = details.style.width;
    details.style.width = 'max-content';
    var width = Math.ceil(details.getBoundingClientRect().width);
    details.style.width = prev;
    return width;
  }

  function expandSort(details) {
    var menu = details.querySelector('.ri-sort__menu');
    if (!menu) return;
    document.querySelectorAll('.ri-sort__details[open]').forEach(function (other) {
      if (other !== details) other.open = false;
    });
    if (details.hasAttribute('data-sort-fixed')) return;
    /* Phone: the control already fills its row. Resizing it on open made it jump. */
    if (window.matchMedia && window.matchMedia('(max-width: 989px)').matches) return;
    var base = sortNaturalWidth(details);
    var target = Math.max(base, sortMenuWidth(menu));
    menu.style.width = '100%';
    menu.style.minWidth = '100%';
    details.style.width = target + 'px';
  }

  function collapseSort(details) {
    var menu = details.querySelector('.ri-sort__menu');
    if (!menu || details.hasAttribute('data-sort-fixed')) return;
    details.style.width = '';
    menu.style.width = '';
    menu.style.minWidth = '';
  }

  /* Phone drops (owner, 2026-10-23: chips popped in during the slide, the black line vanished, and a black line
     flashed at the start). The open list is a still window under the chip row holding a white sheet: the chips and
     the black line under them. Opening slides the sheet down into the window from under the row; closing slides it
     back up. Only the sheet's position changes, so the phone runs the slide on its graphics chip with the sheet
     drawn in full before it moves; nothing inside re-lays out and the line travels with the sheet. No fade.
     0.24s easing out to open, 0.2s easing in to close. */
  var DROP_MS = 240;
  var DROP_EASE = 'cubic-bezier(0.22, 0.61, 0.36, 1)';
  var DROP_CLOSE_MS = 200;
  var DROP_CLOSE_EASE = 'cubic-bezier(0.4, 0, 1, 1)';

  function dropMotionOk(panel) {
    if (!panel || typeof panel.animate !== 'function') return false;
    return !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function sheetOf(panel) {
    return panel ? panel.firstElementChild : null;
  }

  function slideSheet(sheet, down) {
    sheet.style.willChange = 'transform';
    var frames = [{ transform: 'translateY(-100%)' }, { transform: 'translateY(0)' }];
    if (!down) frames.reverse();
    return sheet.animate(frames, {
      duration: down ? DROP_MS : DROP_CLOSE_MS,
      easing: down ? DROP_EASE : DROP_CLOSE_EASE,
      fill: down ? 'none' : 'forwards'
    });
  }

  function growPortal(panel) {
    var sheet = sheetOf(panel);
    if (!sheet || !dropMotionOk(sheet)) return;
    if (panel._riGrow) panel._riGrow.cancel();
    var anim = slideSheet(sheet, true);
    panel._riGrow = anim;
    var done = function () {
      if (panel._riGrow !== anim) return;
      panel._riGrow = null;
      sheet.style.willChange = '';
    };
    anim.onfinish = done;
    anim.oncancel = done;
    /* Never left tucked away if the page's clock stalls. */
    window.setTimeout(function () {
      if (panel._riGrow !== anim) return;
      anim.cancel();
      done();
    }, DROP_MS + 120);
  }

  /* Open, move under the row, place and start the slide in one go, in the tap itself. The browser's toggle event
     comes a moment later: in between, the list drew one frame in its home spot inside the chip row (the black line
     that flashed). A list put back open after a filter change (restoreOpenDrop) is already on screen: no slide. */
  function openFacetDrop(details) {
    if (!details || !details.open || details._riShown) return;
    details._riShown = true;
    closeFacetDrops(details, true);
    document.querySelectorAll('.ri-sort__details[open]').forEach(function (other) {
      other.open = false;
    });
    portalOpen(details);
    var panel = panelOf(details);
    bindFacetPanelScroll(panel);
    placeFacetPanel(details);
    if (panel && panel.classList.contains('is-portal') && !details.classList.contains('ri-facet-drop--keep')) {
      growPortal(panel);
    }
  }

  function closeFacetDrop(details, instant) {
    if (!details || !details.open) return;
    if (details._riClosing && !instant) return;
    var panel = panelOf(details);
    var sheet = sheetOf(panel);
    var shut = function () {
      details._riClosing = null;
      details._riShown = false;
      details.open = false;
      /* Home now, not on the toggle event a moment later, so the list cannot linger for a frame. */
      portalClose(details);
      if (sheet) sheet.style.willChange = '';
    };
    if (instant || !panel || !sheet || !panel.classList.contains('is-portal') || !dropMotionOk(sheet)) {
      if (panel && panel._riGrow) panel._riGrow.cancel();
      if (sheet) sheet.getAnimations().forEach(function (a) { a.cancel(); });
      shut();
      return;
    }
    if (panel._riGrow) {
      /* Cleared first, so the open slide's cleanup does not undo this one. */
      var growing = panel._riGrow;
      panel._riGrow = null;
      growing.cancel();
    }
    var anim = slideSheet(sheet, false);
    var token = {};
    details._riClosing = token;
    var finish = function () {
      if (details._riClosing !== token) return;
      /* Shut and home before the slide lets go, or the sheet flashes back for a frame. */
      shut();
      anim.cancel();
    };
    anim.onfinish = finish;
    window.setTimeout(finish, DROP_CLOSE_MS + 120);
  }

  /* instant: another drop is opening in the same spot, so this one goes at once instead of crossing its slide. */
  function closeFacetDrops(except, instant) {
    document.querySelectorAll('.ri-facet-drop[open]').forEach(function (details) {
      if (details !== except) closeFacetDrop(details, instant);
    });
  }

  /* A tap on a drop's header opens or closes it here, not through the browser's own toggle. */
  function onFacetSummaryClick(event) {
    var summary = event.target && event.target.closest ? event.target.closest('.ri-facet-drop__summary') : null;
    if (!summary) return;
    var details = summary.parentElement;
    if (!details || !details.classList.contains('ri-facet-drop')) return;
    event.preventDefault();
    if (details.open) {
      closeFacetDrop(details);
      return;
    }
    details.open = true;
    openFacetDrop(details);
  }

  /* Phone: a taller header line when the collection title wraps to 2+ lines. */
  function markMultilineHead() {
    /* The fitting itself lives in the inline scripts beside Sort by and the title, so it also runs before first
       paint. Sort by first: the title fits into the room the button leaves. */
    if (typeof window.RIFitSort === 'function') window.RIFitSort();
    if (typeof window.RIFitCollectionTitle === 'function') window.RIFitCollectionTitle();
  }

  function placeFacetPanel(details) {
    var bar = details.closest('.ri-facets__bar');
    var panel = panelOf(details);
    var summary = details.querySelector('.ri-facet-drop__summary');
    if (!bar || !panel || !summary || !details.open) return;
    var barBox = bar.getBoundingClientRect();
    var sumBox = summary.getBoundingClientRect();
    var row = details.closest('.ri-facets__bar-row');
    var rowBox = row ? row.getBoundingClientRect() : barBox;
    /* The chip row runs 1.5px past the white bar under it, so starting at the row left a see-through strip over the
       list (owner, 2026-10-23). Start where the first of the two ends, rounded down. */
    panel.style.top = Math.floor(Math.min(rowBox.bottom, barBox.bottom)) + 'px';
    panel.style.left = Math.round(barBox.left) + 'px';
    panel.style.width = Math.round(barBox.width) + 'px';
    var caret = sumBox.left + sumBox.width / 2 - barBox.left;
    caret = Math.max(14, Math.min(caret, barBox.width - 14));
    panel.style.setProperty('--ri-facet-caret', caret + 'px');
  }

  function bindFacetPanelScroll(panel) {
    if (!panel || panel._riScrollLock) return;
    panel._riScrollLock = true;
    var startY = 0;
    panel.addEventListener(
      'touchstart',
      function (event) {
        if (!event.touches || !event.touches.length) return;
        startY = event.touches[0].clientY;
      },
      { passive: true }
    );
    panel.addEventListener(
      'touchmove',
      function (event) {
        if (!event.touches || !event.touches.length) return;
        var scroller = panel.firstElementChild || panel;
        var y = event.touches[0].clientY;
        var dy = y - startY;
        startY = y;
        var canScroll = scroller.scrollHeight > scroller.clientHeight + 1;
        var atTop = scroller.scrollTop <= 0;
        var atBottom = scroller.scrollTop + scroller.clientHeight >= scroller.scrollHeight - 1;
        if (!canScroll || (atTop && dy > 0) || (atBottom && dy < 0)) event.preventDefault();
      },
      { passive: false }
    );
  }

  function onFacetDropToggle(event) {
    var details = event.target;
    if (!details || !details.classList || !details.classList.contains('ri-facet-drop')) return;
    if (!details.open) {
      details._riShown = false;
      portalClose(details);
      return;
    }
    /* Opened some other way than a tap (restoreOpenDrop, a script): same steps, once. */
    openFacetDrop(details);
  }

  function onSortToggle(event) {
    var details = event.target;
    if (!details || !details.classList || !details.classList.contains('ri-sort__details')) return;
    if (details.open) {
      expandSort(details);
      closeFacetDrops();
    } else {
      collapseSort(details);
    }
  }

  /* The sort control is not re-rendered with the results, so after Back/Forward it must be matched to the URL. */
  function syncSortLabel() {
    var param = new URLSearchParams(window.location.search).get('sort_by');
    document.querySelectorAll('.ri-sort').forEach(function (sort) {
      var select = sort.querySelector('select');
      var valueEl = sort.querySelector('.ri-sort__value');
      if (!select || !valueEl) return;
      var wanted = param || sort.getAttribute('data-default-sort') || '';
      var match = null;
      sort.querySelectorAll('.ri-sort__option').forEach(function (option) {
        if (option.getAttribute('data-value') === wanted) match = option;
      });
      if (!match) return;
      select.value = wanted;
      valueEl.textContent = match.textContent.trim();
      sort.querySelectorAll('.ri-sort__option').forEach(function (option) {
        var on = option === match;
        option.classList.toggle('is-current', on);
        if (on) option.setAttribute('aria-current', 'true');
        else option.removeAttribute('aria-current');
      });
    });
  }

  window.addEventListener('popstate', function () {
    window.setTimeout(syncSortLabel, 0);
    window.setTimeout(syncSortLabel, 600);
  });

  function onSortOption(event) {
    var button = event.target.closest('.ri-sort__option');
    if (!button) return;
    var details = button.closest('.ri-sort__details');
    var sort = button.closest('.ri-sort');
    var select = sort && sort.querySelector('select');
    if (!details || !select) return;
    event.preventDefault();
    var value = button.getAttribute('data-value') || '';
    if (select.value === value) {
      details.open = false;
      var summary = details.querySelector('.ri-sort__summary');
      if (summary) summary.focus();
      return;
    }
    select.value = value;
    /* Show the pick right away; the results swap does not re-render this control. */
    var valueEl = details.querySelector('.ri-sort__value');
    if (valueEl) valueEl.textContent = button.textContent.trim();
    details.querySelectorAll('.ri-sort__option').forEach(function (other) {
      var on = other === button;
      other.classList.toggle('is-current', on);
      if (on) other.setAttribute('aria-current', 'true');
      else other.removeAttribute('aria-current');
    });
    select.dispatchEvent(new Event('input', { bubbles: true }));
    details.open = false;
  }

  function onSortOutside(event) {
    if (!event.target.closest('.ri-sort')) {
      document.querySelectorAll('.ri-sort__details[open]').forEach(function (details) {
        details.open = false;
      });
    }
    if (!event.target.closest('.ri-facet-drop, .ri-facet-drop__panel.is-portal')) closeFacetDrops();
  }

  function onSortKey(event) {
    if (event.key !== 'Escape') return;
    var details = document.querySelector('.ri-sort__details[open]');
    if (!details) return;
    details.open = false;
    var summary = details.querySelector('.ri-sort__summary');
    if (summary) summary.focus();
  }

  var facetFollowFrame = 0;
  function onFacetPanelFollow() {
    if (facetFollowFrame) return;
    facetFollowFrame = window.requestAnimationFrame(function () {
      facetFollowFrame = 0;
      var open = document.querySelector('.ri-facet-drop[open]');
      if (open) placeFacetPanel(open);
    });
  }

  function initSortMenus() {
    document.addEventListener('toggle', onSortToggle, true);
    document.addEventListener('toggle', onFacetDropToggle, true);
    document.addEventListener('click', onFacetSummaryClick, true);
    window.addEventListener('resize', markMultilineHead);
    document.addEventListener('click', onSortOption);
    document.addEventListener('click', onSortOutside);
    document.addEventListener('keydown', onSortKey);
    window.addEventListener('scroll', onFacetPanelFollow, { passive: true });
    window.addEventListener('resize', onFacetPanelFollow);
    document.addEventListener(
      'scroll',
      function (event) {
        if (event.target && event.target.closest && event.target.closest('.ri-facets__bar-row')) onFacetPanelFollow();
      },
      true
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
